import { createStore, applyMiddleware, compose } from 'redux';
import thunk from "redux-thunk";
import rootReducer from "./reducers";
import { persistStateToLocalStorage, restoreStateFromLocalStorage } from './localStorage';
import throttle from 'lodash/throttle';

const middleware = [thunk];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const initialState = restoreStateFromLocalStorage();

// Create the redux store
const store = createStore(rootReducer, initialState, composeEnhancers(
    applyMiddleware(...middleware)
));

/**
 * Subscribe to any state change and persist it to the localstorage
 */
store.subscribe(throttle(() => {
    persistStateToLocalStorage({
        authReducer: store.getState().authReducer
    });
}, 1000));

export default store;